import get from 'lodash/get';
import React from 'react'
import { useTranslation } from 'react-i18next';
import HistoryBlock, { processHistory } from './HistoryBlock';

const HistoryLocationStatus = ({device}) => {
  const { t } = useTranslation();

  return (
    <HistoryBlock
      title={t("devices.LocationAuthorizedHistory")}
      data={
        processHistory("location_authorized")(get(device, 'history.location_authorized'))}
      cloumnTitle="Location Authorized History"
      cloumnAccessor={"location_authorized"}
    />
   );
}

export default HistoryLocationStatus;